import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-success-reset',
  templateUrl: './success-reset.component.html',
  styleUrls: ['./success-reset.component.css']
})
export class SuccessResetComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/login-signup/success-reset/success-reset.component.ts